import { makeStyles } from '@paintscout/ui'
import type { MuiTheme as Theme } from '@paintscout/ui'

export const usePainterScheduleLayoutStyles = makeStyles<Theme>((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    height: '100vh',
    backgroundColor: theme.palette.background.default,
    maxWidth: 480,
    margin: '0 auto',
    [theme.breakpoints.up('md')]: { maxWidth: '100%' }
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(1.5, 2, 1.625),
    backgroundColor: theme.palette.common.white,
    borderBottom: `1px solid ${theme.palette.divider}`,
    flexShrink: 0
  },
  headerInner: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%'
  },
  headerTitle: {
    ...theme.typography.h4,
    fontWeight: theme.typography.fontWeightMedium,
    textAlign: 'center'
  },
  userAvatar: {
    width: 34,
    height: 34,
    borderRadius: '50%',
    objectFit: 'cover',
    backgroundColor: theme.paintscout.palette.brand.Blue.Blue55,
    fontSize: theme.typography.pxToRem(14),
    fontWeight: theme.typography.fontWeightMedium
  },
  avatarBtn: {
    padding: 0,
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    borderRadius: '50%'
  },
  weekNavSection: {
    backgroundColor: theme.palette.common.white,
    padding: theme.spacing(2, 2, 0.75),
    flexShrink: 0
  },
  weekNavRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  weekRangeText: {
    fontSize: theme.typography.pxToRem(14),
    fontWeight: theme.typography.fontWeightMedium,
    color: theme.palette.text.primary
  },
  navArrow: {
    padding: 0,
    color: theme.palette.text.primary
  },
  weekBadge: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: 4,
    padding: theme.spacing(0.25, 0.75),
    border: `1px solid ${theme.paintscout.palette.brand.Neutral.P70}`,
    borderRadius: theme.borderRadius.md,
    backgroundColor: theme.palette.common.white,
    alignSelf: 'center'
  },
  weekBadgeText: {
    fontSize: theme.typography.pxToRem(12),
    color: theme.paintscout.palette.brand.Neutral.P70,
    lineHeight: 1.4
  },
  weekNavCenter: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: theme.spacing(0.5)
  },
  dayStripSection: {
    backgroundColor: theme.palette.common.white,
    padding: theme.spacing(0.75, 2, 1.5),
    flexShrink: 0
  },
  dayStrip: {
    display: 'flex',
    gap: theme.spacing(1.25),
    alignItems: 'center',
    justifyContent: 'center'
  },
  dayButton: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(2, 1),
    height: 70,
    borderRadius: theme.borderRadius.md,
    backgroundColor: theme.palette.background.default,
    cursor: 'pointer',
    border: 'none',
    gap: theme.spacing(0.75),
    flex: 1
  },
  dayButtonSelected: { backgroundColor: theme.paintscout.palette.brand.Blue.Blue55 },
  dayContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: theme.spacing(0.5),
    width: 28
  },
  dayName: {
    fontSize: theme.typography.pxToRem(12),
    fontWeight: theme.typography.fontWeightMedium,
    color: theme.palette.text.primary,
    lineHeight: '16px',
    textAlign: 'center',
    width: '100%'
  },
  dayNameSelected: { color: theme.palette.common.white },
  dayNumber: {
    fontSize: theme.typography.pxToRem(18),
    fontWeight: theme.typography.fontWeightMedium,
    color: theme.palette.text.primary,
    lineHeight: '16px',
    textAlign: 'center',
    width: '100%'
  },
  dayNumberSelected: { color: theme.palette.common.white },
  dayDot: { width: 4, height: 4, borderRadius: '50%', backgroundColor: theme.paintscout.palette.brand.Blue.Blue55 },
  dayDotSelected: { backgroundColor: theme.palette.common.white }
}))
